import QRCode from 'qrcode';

export const toQrCode = (url: string): Promise<string> => {
    return QRCode.toDataURL(url);
};